import { createApp } from 'vue'
import { userService } from '@/http'
import store from '@/store'

import qs from '@/Utils/qs'
import cookie from '@/Utils/cookie'

import '@/styles/base.scss'

import 'virtual:svg-icons-register'

import Icon from '@/Components/Icon.vue'
import Input from '@/Components/Input.vue'
import Link from '@/Components/Link.vue'
import Modal from '@/Components/Modal.vue'
import Loader from '@/Components/Loader.vue'


import lazy from '@/Directives/lazy'

import App from '@/App.vue'
import router from '@/router.js'

const app = createApp(App)
window.app = app;

let ver = qs.v || cookie.get('ver') || 1
cookie.set('ver', ver, 60 * 24 * 365)

app.config.globalProperties.ver = ver
app.config.globalProperties.store = store
app.config.globalProperties.$pixel = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

app.component('Icon', Icon)
app.component('Link', Link)
app.component('VInput', Input)
app.component('Modal', Modal)
app.component('Loader', Loader)

app.directive('lazy', lazy)

const checkAuth = async () => {
    return userService.auth().then(res => {
        store.isAuth = true
        store.user = res
        console.log(res)
    }).catch(err => {})
}

const checkWidth = () => {
    let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    store.size = {
        xs: w >= 768,
        md: w >= 1024
    }
    console.log(store.size)
}

window.addEventListener('resize', checkWidth);



;(async () => {
    checkWidth()
    checkAuth()
    app.use(router)
    app.mount('#app')
})()



